/* Avis clients : filtre par niveau et bouton « Voir plus ». */
(function () {
  function Avis(racine) {
    this.racine = racine;
    this.parPage = parseInt(racine.getAttribute('data-par-page'), 10) || 4;
    this.modele = racine.getAttribute('data-texte-plus') || '';
    this.items = Array.prototype.slice.call(racine.querySelectorAll('.avis__item'));
    this.filtres = Array.prototype.slice.call(racine.querySelectorAll('[data-filtre]'));
    this.zonePlus = racine.querySelector('[data-avis-plus-zone]');
    this.boutonPlus = racine.querySelector('[data-avis-plus]');
    this.filtre = '';
    this.tout = false;
    var self = this;
    this.filtres.forEach(function (b) {
      b.addEventListener('click', function () { self.choisir(b.getAttribute('data-filtre') || ''); });
    });
    if (this.boutonPlus) {
      this.boutonPlus.addEventListener('click', function () { self.tout = true; self.appliquer(); });
    }
  }

  Avis.prototype.choisir = function (niveau) {
    this.filtre = niveau;
    this.filtres.forEach(function (b) {
      b.setAttribute('aria-pressed', (b.getAttribute('data-filtre') || '') === niveau ? 'true' : 'false');
    });
    this.appliquer();
  };

  Avis.prototype.appliquer = function () {
    var etat = Avis.visibles(this.items.map(function (i) { return i.getAttribute('data-niveau') || ''; }), this.filtre, this.parPage, this.tout);
    this.items.forEach(function (item, i) { item.hidden = !etat.visibles[i]; });
    if (this.zonePlus) {
      this.zonePlus.hidden = etat.restants === 0;
      if (this.boutonPlus && etat.restants > 0) this.boutonPlus.textContent = this.modele.replace('[n]', etat.restants);
    }
  };

  /* Calcul pur, testable : quels avis montrer et combien restent cachés. */
  Avis.visibles = function (niveaux, filtre, parPage, tout) {
    var vus = 0;
    var correspondants = 0;
    var visibles = niveaux.map(function (n) {
      if (filtre && n !== filtre) return false;
      correspondants++;
      if (tout || vus < parPage) { vus++; return true; }
      return false;
    });
    return { visibles: visibles, restants: correspondants - vus };
  };

  function initialiser(zone) {
    Array.prototype.forEach.call((zone || document).querySelectorAll('[data-avis]'), function (r) {
      if (!r.__avis) r.__avis = new Avis(r);
    });
  }

  window.AspadelAvis = Avis;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialiser(); });
  else initialiser();
  document.addEventListener('shopify:section:load', function (e) { initialiser(e.target); });
})();
